module.exports = __webpack_public_path__ + "static/media/Banner_Mobile.a4a94933.jpg";